import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  projects: [],
  searchTerm: "",
}; // define your initial state object here

export const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    searchTask: (state, action) => {
      state.searchTerm = action.payload;
    },
    addProjects: (state, action) => {
      state.projects = action.payload;
    },
    editProject: (state, action) => {
      let duplicateState = [...state.projects];
      const target = duplicateState.findIndex(
        (project) => project.id === action.payload.id
      );
      duplicateState[target] = action.payload;
      state.projects = duplicateState;
    },
  },
});

export const { searchTask, addProjects, editProject } = filterSlice.actions;
export default filterSlice.reducer;
